module.exports = __webpack_public_path__ + "static/20190526_073833-f3e3ab8ce5d4d56f692cc5a7ee3cd95f.jpg";